







import { Component, Vue } from 'vue-property-decorator'
import AppartmentRecap from '@/views/profile/AppartmentRecap.vue'
import Progope from '@/components/ProgImmo/Progope.vue'

@Component({
    components: {
        AppartmentRecap,
        Progope,
    },
})
export default class AppartmentRecapView extends Vue {}
